import { color, radio } from '#components/mobile/ui/tokens';

/** Caja plana de la tripulación (sin sombra): Gavi, listas y ayuda. */
export const tarjetaPlana = {
  borderRadius: radio.tarjeta - 4,
  backgroundColor: color.surface,
  border: `1px solid ${color.line}`,
  flexShrink: 0,
} as const;
